import Link from "next/link";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-2xl px-4 py-8">
        <Link
          href="/auth/signup"
          className="mb-6 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Link>

        <h1 className="text-3xl font-bold">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Last updated: February 2026
        </p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">1. Information We Collect</h2>
            <p>We collect information you provide when creating an account and using the Platform:</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              <li>Name, email address, and phone number</li>
              <li>ABN and company details (contractors)</li>
              <li>Trade, experience, certifications, and availability (workers)</li>
              <li>Location (suburb/area) for job matching</li>
              <li>Voice recordings (if you use voice input features)</li>
              <li>Payment information (processed by Stripe)</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">2. How We Use Your Information</h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>To create and manage your account</li>
              <li>To match workers with relevant job opportunities</li>
              <li>To process payments for hiring fees</li>
              <li>To generate AI-powered profiles and suggestions</li>
              <li>To send notifications about matches and hires</li>
              <li>To improve our services</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">3. AI and Voice Data</h2>
            <p>
              We use AI services (OpenAI) to generate profile content and transcribe voice
              recordings. Voice recordings are processed in real-time and are not permanently
              stored. AI-generated content is stored as part of your profile.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">4. Data Sharing</h2>
            <p>We share your information with:</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              <li>Other users (your profile is visible to contractors/workers on the Platform)</li>
              <li>Stripe (for payment processing)</li>
              <li>OpenAI (for AI features — voice transcription and profile generation)</li>
              <li>Supabase (our database and authentication provider)</li>
            </ul>
            <p className="mt-2">We do not sell your personal information to third parties.</p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">5. Data Security</h2>
            <p>
              We use industry-standard security measures including encryption, secure
              authentication, and access controls to protect your data. All data is stored
              in secure cloud infrastructure.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">6. Your Rights</h2>
            <p>Under the Australian Privacy Act 1988, you have the right to:</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your account and data</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">7. Cookies</h2>
            <p>
              We use essential cookies for authentication and security (CSRF protection).
              We do not use tracking or advertising cookies.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">8. Contact</h2>
            <p>
              For privacy enquiries, contact us at privacy@rateright.com.au.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
